import { render, staticRenderFns } from "./SetGuestUsername.vue?vue&type=template&id=1046bf94&scoped=true"
import script from "./SetGuestUsername.vue?vue&type=script&lang=js"
export * from "./SetGuestUsername.vue?vue&type=script&lang=js"
import style0 from "./SetGuestUsername.vue?vue&type=style&index=0&id=1046bf94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1046bf94",
  null
  
)

export default component.exports